import React, { Component } from "react";

export class Loader extends Component {
  render() {
    const { text, background, centered } = this.props;
    return (
      <div className={centered ? "centerLoader" : ""}>
        <div
          className={
            background
              ? ""
              : "tfx-user-form-wrapper box-effect full-border white-bg"
          }
        >
          <div className="tfx-user-form-inner">
            {/* Loader */}
            <div
              id="adv-login-loader"
              className="loading-overlay speed-1x fadeInRight"
            >
              <div className="form-loader form-loader-login verify">
                <div className="centerLoader">
                  <div className="loading" id="adv-loader-alt" />
                  <div className="center-txt webapp-ripple-text">
                    {/* <i className="notifier fas fa-user-circle"/> */}
                    &nbsp; {`${text}`}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export const SuccessLoader = (props) => {
  const { text, subText } = props;
  const classList = props.className ? props.className : "speed-1x fadeInRight";

  return (
    <div className="tfx-user-form-inner">
      {/* Success response*/}
      <div id="adv-login-response" className={`loading-overlay ${classList}`}>
        <div className="form-loader form-loader-login verify">
          <div className="centerLoader">
            <div className="loading success-loader">
              <i className="webapp-ripple-notification success-text fa fa-check-circle" />
            </div>
            <div className="center-txt webapp-ripple-text">&nbsp; {text}</div>
            {subText && (
              <div className="onboarding-response center-txt webapp-ripple-text">
                &nbsp; {subText}
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export const ErrorLoader = (props) => {
  const { text, subText, icon } = props;
  const classList = props.className ? props.className : "speed-1x fadeInRight";

  return (
    <div className="tfx-user-form-wrapper box-effect full-border white-bg animated fadeInRight">
      <div className="tfx-user-form-inner">
        {/* Error Response */}
        <div id="adv-login-response" className={`loading-overlay ${classList}`}>
          <div className="form-loader form-loader-login verify">
            <div className="centerLoader">
              <div className="loading">
                {icon ? (
                  <i
                    className={`webapp-ripple-notification error-text ${icon}`}
                  />
                ) : (
                  <i className="webapp-ripple-notification error-text fa fa-times-circle" />
                )}
              </div>
              <div className="center-txt webapp-ripple-text">&nbsp; {text}</div>
              {subText && (
                <div className="onboarding-response center-txt webapp-ripple-text">
                  &nbsp; {subText}
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export const InfoLoader = (props) => {
  const { background, text, subText } = props;
  const classList = props.className ? props.className : "speed-1x fadeInRight";

  return (
    <div
      className={
        background
          ? `${classList}`
          : `tfx-user-form-wrapper box-effect full-border white-bg ${classList}`
      }
    >
      <div className="tfx-user-form-inner">
        {/* Information Response */}
        <div id="adv-login-response" className={`loading-overlay ${classList}`}>
          <div className="form-loader form-loader-login verify">
            <div className="centerLoader">
              <div className="">
                <i className="webapp-ripple-notification success-text fa fa-bell" />
              </div>
              <div className="center-txt webapp-ripple-text">&nbsp; {text}</div>
              {subText && (
                <div className="onboarding-response center-txt webapp-ripple-text">
                  &nbsp; {subText}
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default function ButtonLoader() {
  return <span className="spinner-border spinner-border-sm ml-2"></span>;
}
